import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function TestimonialsSection() {
  const media = [{
    type: 'image',
    src: 'https://cdn.magicpatterns.com/uploads/q2oYQ1V4UoAK5d1A8WP9M5/TESTIMONIO_EMANUEL.png'
  }, {
    type: 'image',
    src: 'https://cdn.magicpatterns.com/uploads/1kmwSperWezu5CZ5SU8XhG/RETIRO_QUOTEX_1700.png'
  }, {
    type: 'video',
    src: 'https://cdn.magicpatterns.com/uploads/4nsXCyVmo5coJiDFnVjz1o/DAMIAN VIDEO.mp4'
  }, {
    type: 'video',
    src: 'https://cdn.magicpatterns.com/uploads/kbG8d3ABQck7CGzJuLB7os/PEDRO.mp4'
  }, {
    type: 'image',
    src: 'https://cdn.magicpatterns.com/uploads/bN7WEyfWzkDVWANcdf83MG/TESTIMONIOS_VARIOS.png'
  }, {
    type: 'video',
    src: 'https://cdn.magicpatterns.com/uploads/j8jv13EKaiC8DsW4qYa5e2/DAMIAN 2.mp4'
  }];
  return <section id="testimonios" className="py-24 md:py-32 bg-neutral-900 border-y border-neutral-800" data-id="element-333">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-334">
        <FadeIn data-id="element-335">
          <div className="text-center mb-16" data-id="element-336">
            <h2 className="text-3xl md:text-5xl font-black text-white tracking-tight uppercase mb-4" data-id="element-337">
              Alumnos que dejaron de improvisar
            </h2>
            <p className="text-red-500 font-medium tracking-widest uppercase text-sm" data-id="element-338">
              No vendo promesas. Vendo un proceso.
            </p>
          </div>
        </FadeIn>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-339">
          {media.map((item, idx) => <FadeIn key={idx} delay={0.1 * (idx % 3)} data-id="element-340">
              <div className="aspect-[4/5] bg-[#121212] border border-neutral-800 rounded-sm flex items-center justify-center relative overflow-hidden group" data-id="element-341">
                {item ? item.type === 'video' ? <video src={item.src} autoPlay loop muted playsInline className="absolute inset-0 w-full h-full object-contain" data-id="element-342" /> : <img src={item.src} alt={`Testimonio ${idx + 1}`} className="absolute inset-0 w-full h-full object-contain" data-id="element-343" /> : <div className="absolute inset-0 flex flex-col items-center justify-center text-neutral-700 group-hover:text-neutral-600 transition-colors" data-id="element-344">
                    <span className="block w-12 h-12 border-2 border-current rounded-sm mb-3 opacity-50" data-id="element-345" />
                    <span className="text-xs font-mono uppercase tracking-widest opacity-50" data-id="element-346">
                      Captura {idx + 1}
                    </span>
                  </div>}

                {/* Subtle overlay effect */}
                <div className="absolute inset-0 bg-gradient-to-t from-neutral-950/80 to-transparent opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none" data-id="element-347" />
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}